<template>
  <div>
    <button-logout-white @click="openModal">ログアウト</button-logout-white>

    <popup-modal v-model="logoutModal" @close="closeModal" @close-layer="closeModal" name="S6-1-logout-modal-close-btn">
      <template #main>
        <div class="c-popup-body__head">
          <p class="c-popup-body__head-title">
            ログアウト
          </p>
        </div>
        <div class="c-popup-body__titleBox">
          <div class="c-popup-body__titleBox-logout">
            本当にログアウトしますか？
          </div>
        </div>
      </template>
      <template #footer>
        <button-logout-blue @click="logout">ログアウト</button-logout-blue>
        <div class="c-button -right">
          <button-white @click="closeModal" :no-icon="true" name="S6-1-logout-modal-cancel-btn">キャンセル</button-white>
        </div>
      </template>
    </popup-modal>
  </div>
</template>

<script setup lang="ts">
  import {ref} from 'vue';
  import { useAuthStore } from '@/store/student/auth_store';

  const logoutModal = ref(false)

  function logout() {
    useAuthStore().authLogout().then(() => window.location.replace("/student/login/"))
        .catch(e => console.log("error: ", e))
  }

  function openModal() {
    logoutModal.value = true
  }

  function closeModal() {
    logoutModal.value = false
  }
</script>
